// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".center[data-v-0424ea1c]{height:100vh;display:flex;flex-flow:column nowrap;justify-content:center;align-items:center}.center .font[data-v-0424ea1c]{font-size:.4rem}.center .btn[data-v-0424ea1c]{font-size:.3rem;margin-top:.6rem;height:.6rem;width:3rem;text-align:center;background:#61bc6c;color:#fff;line-height:.6rem}", ""]);
// Exports
module.exports = exports;
